export default "__VITE_ASSET__CfMR7SMG__"